import SummarizeIcon from '@mui/icons-material/Summarize';
import WarehouseIcon from '@mui/icons-material/Warehouse';

const icoMenu = {
    SummarizeIcon,
    WarehouseIcon
};

// ==============================|| REPORTERÍA MENU ITEMS - DOCTOR ||============================== //

const reportes = {
    id: 'reporteria',
    title: '',
    type: 'group',
    children: [
        {
            id: 'reportes_menu',
            title: 'Reportería',
            type: 'collapse',
            icon: icoMenu.SummarizeIcon,
            children: [
                {
                    id: 'reportes_de_control',
                    title: 'Reportes de Control',
                    type: 'collapse',
                    icon: icoMenu.WarehouseIcon,
                    children: [
                        {
                            id: 'inventario_diario_medicamentos',
                            title: 'Inventario diario medicamentos',
                            type: 'item',
                            url: '/user/reportes-inventario-diario-medicamentos-view'
                        }
                    ]
                }
            ]
        }
    ]
};

export default reportes;
